import { TextField, Tooltip } from '@mui/material';
import React from 'react';
import { FieldHookConfig, useField } from 'formik';
import { useAuth } from '../../hooks/use-auth.hook';
import { InputProps as StandardInputProps } from '@mui/material/Input/Input';

/**
 * Objet qui permet d'avoir les props de formik plus les attributs que le veut custom
 */
type MyInputProps = FieldHookConfig<string> & {
    required?: boolean;
    id: string;
    label?: string;
    name: string;
    type?: string;
    maxDate?: string;
    tooltipMessage?: JSX.Element | null;
    handleChange?: (password: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
    InputProps?: Partial<StandardInputProps>;
    autoComplete?: string;
    multiline?: boolean;
    maxRows?: number;
    maxLength?: number;
    rows?: number;
    disabled?: boolean;
    placeholder?: string;
    accept?: string;
};

/**
 * Composant select
 * @param props MyInputProps
 * @constructor
 */
export default function InputForm(props: Readonly<MyInputProps>) {
    // Usefield
    const [field, meta] = useField(props);
    // Contexte d'auth
    const auth = useAuth();

    //Création du champ input
    const input = (
        <TextField
            {...field}
            required={props.required}
            id={props.id}
            label={props.label}
            name={props.name}
            type={props.type}
            fullWidth
            data-testid={props.id}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && Boolean(meta.error) && meta.error}
            inputProps={{
                max: props.type === 'date' ? props.maxDate : undefined,
                maxLength: props.maxLength,
                placeholder: props.placeholder || undefined,
                accept: props.accept || undefined,
            }}
            InputLabelProps={{ shrink: props.type === 'date' || props.type === 'file' ? true : undefined }}
            InputProps={props.InputProps}
            autoComplete={props.autoComplete}
            multiline={props.multiline}
            maxRows={props.maxRows}
            rows={props.rows}
            disabled={(auth.user && auth.user.emailLoggedInAS != null) || props.disabled}
            placeholder={props.placeholder}
            onChange={event => {
                event.preventDefault();
                //Code pour handlerChange spécifique
                if (event.target.value.length > 0 && props.handleChange) {
                    props.handleChange(event);
                }
                field.onChange(event);
            }}
        ></TextField>
    );
    //On retourne le composant
    //Soit avec un tooltip si demandé sinon juste le input
    if (props.tooltipMessage) {
        return (
            <Tooltip title={props.tooltipMessage} arrow>
                {input}
            </Tooltip>
        );
    }

    return input;
}
